import React, { useContext, useState, useEffect } from 'react';

import CheckIcon from 'material-ui/svg-icons/navigation/check';
import RejectIcon from 'material-ui/svg-icons/content/clear';
import RemoveIcon from 'material-ui/svg-icons/action/delete';

import withBasicIconButton from "../Basic/BasicIconButton";

import "../../Base/AwaitableBtn/styles.scss";
import api from 'services';
import { RemoveRowContext } from '../TcIndexPage';
import { NotificationContext } from '../TcIndex';
import { notifications } from '../common';
import { isValidUuid } from 'helpers/miscellaneous';

function _Approve({ countIndex, confirmed, hireDataId, changeFieldsMultiple }) {
    const addNotification = useContext(NotificationContext);
    const [isLoaded, setIsLoaded] = useState(true);

    const approve = () => {
        if (confirmed) return;
        setIsLoaded(false);

        api.approveHireIdea(hireDataId)
            .then(res => {
                if (!res.errors || !res.errors.length) {
                    changeFieldsMultiple([
                        {
                            index: countIndex,
                            field: 'confirmed',
                            value: true,
                        },
                        {
                            index: countIndex,
                            field: 'rejected',
                            value: false,
                        },
                    ]);
                    setIsLoaded(true);
                    addNotification(notifications.success("Approved successfully."));
                } else {
                    addNotification(notifications.error(res.errors[0].message));
                }
            });
    };

    return (
        <div className={`awaitable-btn ${isLoaded?'':'wait'}`}>
            {
                isLoaded &&
                    <CheckIcon
                        onClick={approve}
                        color={confirmed ? '#eaeaea' : 'green'}
                    />
            }
        </div>
    );
}

export const Approve = withBasicIconButton(_Approve);

function _Reject({ countIndex, rejected, hireDataId, changeFieldsMultiple }) {
    const addNotification = useContext(NotificationContext);
    const [isLoaded, setIsLoaded] = useState(true);
    const [isNew, setIsNew] = useState(false);

    useEffect(() => {
        if (isValidUuid(hireDataId)) {
            setIsNew(true);
        }
    }, [hireDataId])

    const reject = () => {
        if (rejected) return;
        if (isNew) return;

        setIsLoaded(false);

        api.rejectHireIdea(hireDataId)
            .then(res => {
                if (!res.errors || !res.errors.length) {
                    changeFieldsMultiple([
                        {
                            index: countIndex,
                            field: 'rejected',
                            value: true,
                        },
                        {
                            index: countIndex,
                            field: 'confirmed',
                            value: false,
                        },
                    ]);
                    setIsLoaded(true);
                    addNotification(notifications.success("Rejected successfully."));
                } else {
                    addNotification(notifications.error(res.errors[0].message));
                }
            });
    };

    return (
        <div className={`awaitable-btn ${isLoaded?'':'wait'}`}>
            {
                isLoaded &&
                    <RejectIcon 
                        onClick={reject}
                        color={rejected || isNew ? '#eaeaea' : '#F4A261'}
                    />
            }
        </div>
    );
}

export const Reject = withBasicIconButton(_Reject);

function _Remove({ countIndex, hireDataId}) {
    const addNotification = useContext(NotificationContext);
    const removeRow = useContext(RemoveRowContext)
    const [isLoaded, setIsLoaded] = useState(true);

    const remove = () => {
        if (isValidUuid(hireDataId)) {
            removeRow(countIndex);
            setIsLoaded(true);
            addNotification(notifications.success("Removed successfully."));

            return;
        }

        api.updateHireIdea({ delete: [hireDataId] })
            .then(res => {
                if (!res.errors || !res.errors.length) {
                    removeRow(countIndex);
                    setIsLoaded(true);
                    addNotification(notifications.success("Removed successfully."));
                } else {
                    addNotification(notifications.error(res.errors[0].message));
                }
            })
    };

    return (
        <div className={`awaitable-btn ${isLoaded?'':'wait'}`}>
            {
                isLoaded &&
                    <RemoveIcon 
                        onClick={remove}
                        color='red'
                    />
            }
        </div>
    );
}

export const Remove = withBasicIconButton(_Remove);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/ManageButtons.jsx